module.exports = {
  keyList: {
    projectName: window._env_.REACT_APP_projectName,
    projectUrl: window._env_.REACT_APP_projectUrl,
  },
};
